module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Commit-f428b8384cca3d8d97cc89c9eff56d58.svg";